'use client';

import classNames from '@sindresorhus/class-names';
import {HeaderProps} from '@ui-kit/src/Header/Header.types';
import {useEffect, useState} from 'react';

import {Anchors} from './components/Anchors';
import {Links} from './components/Links';
import {Logo} from './components/Logo';
import styles from './Header.module.scss';

export const Header = ({
  links,
  onLinkClick,
  onAnchorLinkClick,
  anchorLinks,
  logo,
  rightSideContent,
  mobileMenu,
  activeLinkOrder,
  isRedesignAnchors,
}: HeaderProps) => {
  const [isTopScroll, setTopScroll] = useState(true);
  const [isMobileMenuVisible, setMobileMenuVisible] = useState(false);
  const [removeScrollClass, setRemoveScrollClass] = useState('');

  useEffect(() => {
    const pathName = document.location.pathname;

    const hasRemoveScrollClass = /^\/(catalog|osaurora)/.test(pathName);

    if (hasRemoveScrollClass) {
      // Пока что изолируется только по месту использования RemoveScroll
      import('react-remove-scroll')
        .then((data) =>
          setRemoveScrollClass(data.RemoveScroll.classNames.fullWidth),
        )
        .catch(() => null);
    }

    if (!window.IntersectionObserver) {
      return;
    }

    const containerEl = document.createElement('img');
    containerEl.className = styles.hidedScrollImg;
    containerEl.alt = '';

    (document.getElementById('root') || document.body).append(containerEl);

    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        setTopScroll(entries[0].isIntersecting);
      },
      {threshold: 1},
    );

    intersectionObserver.observe(containerEl);

    return () => {
      intersectionObserver.disconnect();
    };
  }, []);

  return (
    <header className={styles.wrapper}>
      <div
        className={classNames(styles.headerWrapper, {
          [styles.scrollHeader]: !isTopScroll,
        })}
        data-topscroll={isTopScroll}
      >
        <div
          className={classNames(styles.header, removeScrollClass, {
            [styles.animPaddings]: isTopScroll,
          })}
        >
          <Logo logo={logo} isMenuOpened={isMobileMenuVisible} />
          <Links
            activeLinkOrder={activeLinkOrder}
            isMobileMenuVisible={isMobileMenuVisible}
            setMobileMenuVisible={setMobileMenuVisible}
            links={links}
            onLinkClick={onLinkClick}
            mobileMenu={mobileMenu}
          />
          <div className={styles.rightSideContent}>{rightSideContent}</div>
        </div>
      </div>
      <Anchors
        anchorLinks={anchorLinks}
        onAnchorLinkClick={onAnchorLinkClick}
        isRedesignAnchors={isRedesignAnchors}
      />
    </header>
  );
};
